import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";
import { getBrowserLanguage } from "utils/common";

export const useResetPasswordRequestMutation = () =>
  useTypedMutation<string, void>({
    mutationFn: async email => (await ApiInstance.post(`/password/forgot`, { email, language_code: getBrowserLanguage() }, ENV.authBaseURL)).data,
    onSuccess: () => null,
    onError: () => null
  });
